export enum SA_PROGRAMS {
    /**
     * @value Add at least one Manager
     * @description Error message if no manager is added
     */
    AT_LEAST_ONE_MANAGER = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_MEMBERSHIP.AT_LEAST_ONE_MANAGER',
    /**
     * @value Create program
     */
    CREATE_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.CREATE_PROGRAM',
    /**
     * @value Create a new Program to allow users to share content on social networks.
     */
    CREATE_PROGRAM_CTA = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_LIST.CREATE_PROGRAM_CTA',
    /**
     * @value Delete program
     */
    DELETE_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAM.DELETE_PROGRAM',
    /**
     * @value Edit program
     */
    EDIT_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAMS.EDIT_PROGRAM',
    /**
     * @value An error occurred when fetching the program information.
     * @description Error message if an error occurred when fetching the program informations. You can take inspiration from the key FRONT.SOCIAL_ADVOCACY.PROGRAM_DELETE.ERROR :
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=50305166
     */
    ERROR_FETCHING_PROGRAM_INFO = 'SA_PROGRAMS.ERROR_FETCHING_PROGRAM_INFO',
    /**
     * @value Error loading data, please try again.
     */
    FETCH_DATA_RETRY_DESC = 'SA_ANALYTICS_FETCH_DATA_RETRY_DESC',
    /**
     * @value You have reached the limit of %LIMIT% members for this program.
     */
    LIMIT_REACHED = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_MEMBERSHIPS.LIMIT_REACHED',
    /**
     * @value New program
     */
    NEW_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAMS.NEW_PROGRAM',
    /**
     * @value There are no Social Advocacy Programs.
     */
    NO_PROGRAMS = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_LIST.NO_PROGRAMS',
    /**
     * @value Programs
     */
    PROGRAMS = 'ADMIN.NAV.SOCIAL_ADVOCACY.PROGRAMS',
    /**
     * @value There was an issue while checking availability of the name.
     */
    PROGRAM_CREATION_ERROR_CHECKING_NAME = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.CHECKING.NAME',
    /**
     * @value There was an issue while checking availability of the URL.
     */
    PROGRAM_CREATION_ERROR_CHECKING_SLUG = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.CHECKING.SLUG',
    /**
     * @value This name is already used by another page.
     */
    PROGRAM_CREATION_ERROR_DUPLICATE_NAME = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.DUPLICATE.NAME',
    /**
     * @value This URL is already used by another page.
     */
    PROGRAM_CREATION_ERROR_DUPLICATE_SLUG = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.DUPLICATE.SLUG',
    /**
     * @value Give your program a name.
     */
    PROGRAM_CREATION_ERROR_REQUIRED_NAME = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.REQUIRED.NAME',
    /**
     * @value Choose a URL for your program.
     */
    PROGRAM_CREATION_ERROR_REQUIRED_SLUG = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.ERROR.REQUIRED.SLUG',
    /**
     * @value An error occurred while creating the program.
     * @description Message shown when a program is successfully saved
     */
    PROGRAM_CREATION_FAILURE = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.FAILURE',
    /**
     * @value URL
     */
    PROGRAM_CREATION_FIELD_SLUG = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.FIELD.SLUG',
    /**
     * @value Members
     */
    PROGRAM_CREATION_STEP_MEMBERS_LABEL = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.STEP.MEMBERS.LABEL',
    /**
     * @value Social networks
     */
    PROGRAM_CREATION_STEP_SOCIAL_NETWORKS_LABEL = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.STEP.SOCIAL_NETWORKS.LABEL',
    /**
     * @value The program has been successfully created.
     */
    PROGRAM_CREATION_SUCCESS = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.SUCCESS',
    /**
     * @value An error occurred when deleting the program.
     */
    PROGRAM_DELETE_ERROR = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_DELETE.ERROR',
    /**
     * @value <strong>%PROGRAM_NAME%</strong> program will be <strong>deleted permanently</strong>. Members won’t be able to share content or access it anymore. Intranet content shared on social networks will remain accessible.
     */
    PROGRAM_DELETE_EXPLANATION = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_DELETE.EXPLANATION',
    /**
     * @value The program has been deleted successfully.
     */
    PROGRAM_DELETE_SUCCESS = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_DELETE.SUCCESS',
    /**
     * @value An error occurred while saving the program.
     * @description Message shown when a program is successfully saved
     */
    PROGRAM_EDITION_FAILURE = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_EDITION.FAILURE',
    /**
     * @value This program has been successfully saved.
     * @description Message shown when a program is successfully saved
     */
    PROGRAM_EDITION_SUCCESS = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_EDITION.SUCCESS',
    /**
     * @value Program selection is temporarily unavailable.
     */
    PROGRAM_SELECTION_UNAVAILABLE = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_SELECTION.UNAVAILABLE',
    /**
     * @value Remove from program
     */
    REMOVE_FROM_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_MEMBERSHIP.REMOVE_FROM_PROGRAM',
    /**
     * @value Search by name
     */
    SEARCH_BY_NAME = 'FRONT.SOCIAL_ADVOCACY.MEMBERS.SORT.SEARCH_BY_NAME',
    /**
     * @value Select a program
     */
    SELECT_A_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_SELECTION.SELECT_A_PROGRAM',
    /**
     * @value Select program
     * @description Label for an action button. Read it as "Select the program"
     */
    SELECT_PROGRAM = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_SELECTION.SELECT_PROGRAM',
    /**
     * @value Sorted by %SORT%
     */
    SORTED_BY = 'FRONT.SOCIAL_ADVOCACY.MEMBERS.SORTED_BY',
    /**
     * @value new members
     */
    SORT_NEW_MEMBERS = 'FRONT.SOCIAL_ADVOCACY.MEMBERS.SORT.NEW_MEMBERS',
    /**
     * @value Social Advocacy is temporarily unavailable.
     */
    UNAVAILABLE = 'FRONT.SOCIAL_ADVOCACY.ERROR.UNAVAILABLE',
}
export const getSortByRoleKey = (role: string) => `FRONT.SOCIAL_ADVOCACY.MEMBERS.FILTER.${role}`;

export enum PROGRAM_CREATION_ERROR_DUPLICATE {
    /**
     * @value This name is already used by another page.
     */
    NAME = SA_PROGRAMS.PROGRAM_CREATION_ERROR_DUPLICATE_NAME,
    /**
     * @value This URL is already used by another page.
     */
    SLUG = SA_PROGRAMS.PROGRAM_CREATION_ERROR_DUPLICATE_SLUG,
}
export enum PROGRAM_CREATION_ERROR_CHECKING {
    /**
     * @value There was an issue while checking availability of the name.
     */
    NAME = SA_PROGRAMS.PROGRAM_CREATION_ERROR_CHECKING_NAME,
    /**
     * @value There was an issue while checking availability of the URL.
     */
    SLUG = SA_PROGRAMS.PROGRAM_CREATION_ERROR_CHECKING_SLUG,
}
